import * as types from './types';

const initialState = {
  getYusaOvernightCampOverview: {},
  getBrachYearWiseReport: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_SUCCESS: {
      return {
        ...state,
        getYusaOvernightCampOverview: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_BRACH_YEAR_WISE_REPORT_SUCCESS: {
      return {
        ...state,
        getBrachYearWiseReport: action.payload
      };
    }
    case types.GET_BRACH_YEAR_WISE_REPORT_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
